module.exports = __webpack_public_path__ + "static/media/P2-sm-open.a80a4eec.svg";